<template>
  <div
    class="col-sm-12 col-lg-6"
    v-if="$store.state.board.processed"
  >
    <div class="card card-body">
      <span>{{ $store.state.project.repository }}</span>
      <div class="d-flex justify-content-between">
        <h4>
          {{ $store.state.project.title }}
          <small class="text-body-secondary margin-left-1">
            {{ $t('ProjectSpecsCard.projectCode') }}: {{ $store.state.project.token }}
          </small>
        </h4>

        <div
          class="d-flex justify-content-between align-self-baseline"
          v-if="$store.state.loggedIn && !$store.state.project.draft"
        >
          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#project-rename"
          >
            <i
              class="fas fa-pen edit-pen ml-1"
              style="cursor: pointer;"
            />
          </a>
        </div>
      </div>

      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            href="#"
            class="nav-link active"
            data-bs-toggle="tab"
            data-bs-target="#pcbTab"
          >
            {{ $t('ProjectSpecsCard.pcbTab') }}
          </a>
        </li>
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            data-bs-toggle="tab"
            data-bs-target="#stencilTab"
          >
            {{ $t('ProjectSpecsCard.stencilTab') }}
          </a>
        </li>
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            data-bs-toggle="tab"
            data-bs-target="#assemblyTab"
          >
            {{ $t('ProjectSpecsCard.assemblyTab') }}
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane fade show active" id="pcbTab" role="tabpanel">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>{{ $t('ProjectSpecsCard.dimension') }}</td>
                <td>
                  {{
                    ($store.state.board.pcb_width >= 0 && $store.state.board.pcb_height >= 0) ?
                      (`${$store.state.board.pcb_width}mm x ${$store.state.board.pcb_height}mm`) :
                      $t('ProjectSpecsCard.notPresent')
                  }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.layerCount') }}</td>
                <td>
                  {{
                    $store.state.board.layer_count >= 0 ?
                      $store.state.board.layer_count :
                      $t('ProjectSpecsCard.notPresent')
                  }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.minDrillDiameter') }}</td>
                <td>
                  {{
                    $store.state.board.min_drill_diameter > 0 ? ($store.state.board.min_drill_diameter + 'mm') :
                    $t('ProjectSpecsCard.notPresent')
                  }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.elongatedHoleCount') }}</td>
                <td>
                  {{
                    $store.state.board.elongated_holes_count >= 0 ? $store.state.board.elongated_holes_count :
                    $t('ProjectSpecsCard.notPresent')
                  }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.castellatedHoleCount') }}</td>
                <td>
                  {{
                    $store.state.board.castellated_hole_count >= 0 ? $store.state.board.castellated_hole_count :
                    $t('ProjectSpecsCard.notPresent')
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade" id="stencilTab" role="tabpanel">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>{{ $t('ProjectSpecsCard.smdPadCountTop') }}</td>
                <td>{{ $store.state.board.smd_pad_count_top }}</td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.smdPadCountBottom') }}</td>
                <td>{{ $store.state.board.smd_pad_count_bottom }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade" id="assemblyTab" role="tabpanel">
          <table class="table table-striped" v-if="$store.state.board.parts">
            <tbody>
              <tr>
                <td>{{ $t('ProjectSpecsCard.totalPartCount') }}</td>
                <td>{{ $store.state.board.parts.totalCount }}</td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.mountTypeCount') }}</td>
                <td>
                  {{ $store.state.board.parts.smtCount }} / {{ $store.state.board.parts.thtCount }} /
                  {{ $store.state.board.parts.pressFitCount }} / {{ $store.state.board.parts.unknownMountCount }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('ProjectSpecsCard.topAndBottomPartCount') }}</td>
                <td>{{ $store.state.board.parts.topCount }} / {{ $store.state.board.parts.bottomCount }}</td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            No data
          </div>
        </div>
      </div>

      <div class="d-flex pt-3 justify-content-between">
        <div>
          {{ $t('ProjectSpecsCard.stackupHint') }}
        </div>
        <div>
          <a
            class="card-link"
            target="_blank"
            href="https://community.aisler.net/t/pcb-design-rules/41"
          >{{ $t('ProjectSpecsCard.link') }}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12" v-else>
    <div class="card">
      <div class="card-body">
        <h4 class="text-center">
          {{ $t('ProjectSpecsCard.preparingProductionData') }}
        </h4>
        <p>{{ $t('ProjectSpecsCard.preparingDescription') }}</p>

        <p class="text-center">
          <BeatLoader />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import messages from 'locales/ProjectSpecsCard';
import BeatLoader from 'components/shared/BeatLoader.vue';

export default {
  components: { BeatLoader },
  data() {
    return {
      activeTab: 'pcb',
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>

.edit-pen {
  color: gray;

  &:hover {
    color: orange;
  }
}
</style>
